export default () => ({
  gridContainerButton: {
    marginBottom: 24,
  },
})
